import { render, staticRenderFns } from "./QuoteFollowUpList.vue?vue&type=template&id=1c5e59d2&"
import script from "./QuoteFollowUpList.vue?vue&type=script&lang=js&"
export * from "./QuoteFollowUpList.vue?vue&type=script&lang=js&"
import style0 from "./QuoteFollowUpList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports